var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 93 93",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Plus_svg__clip0_9_230)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 0a46.5 46.5 0 100 93 46.5 46.5 0 000-93zm0 85.25a38.75 38.75 0 110-77.5 38.75 38.75 0 010 77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15 48.55a2.9 2.9 0 00-2.05-4.95h-8.7v-8.7a2.9 2.9 0 10-5.8 0v8.7h-8.7a2.9 2.9 0 100 5.8h8.7v8.7a2.9 2.9 0 105.8 0v-8.7h8.7a2.9 2.9 0 002.05-.85z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Plus_svg__clip0_9_230"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h93v93H0z"
  })))));
};

export default SvgPlus;